var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"ats"},_vm._l((_vm.rows),function(row){return _c('div',{key:row,staticClass:"ats__row",style:({ '--ats-stagger': `${row * 70}ms` })},_vm._l((_vm.cells),function(cell,index){return _c('div',{key:index,staticClass:"ats__cell",class:[
        `ats__cell--${cell.align || (index === 0 ? 'left' : 'center')}`,
        { 'ats__cell--buttons': cell.type === 'buttons' },
      ]},_vm._l((_vm.barsFor(cell)),function(bar,barIndex){return _c('span',{key:barIndex,staticClass:"ats__bar",class:`ats__bar--${bar.shape}`,style:(bar.style)})}),0)}),0)}),0)
}
var staticRenderFns = []

export { render, staticRenderFns }